import { render, staticRenderFns } from "./embeddedSignup.vue?vue&type=template&id=52d66968"
import script from "./embeddedSignup.vue?vue&type=script&lang=js"
export * from "./embeddedSignup.vue?vue&type=script&lang=js"
import style0 from "./embeddedSignup.vue?vue&type=style&index=0&id=52d66968&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports